module.exports = __webpack_public_path__ + "static/media/66800021-zoF0wSgs.530cd75a.JPG";